export const T = {
  en_GB: {
    selectOption: "Select an option...",
    fieldRequired: "This field is required",
    saveFailed: "Failed to save your answer. Please try again.",
  },
  nb_NO: {
    selectOption: "Velg et alternativ...",
    fieldRequired: "Dette feltet er påkrevd",
    saveFailed: "Kunne ikke lagre svaret ditt. Vennligst prøv igjen.",
  },
} as const;
